<div class="search-toolbar">
	<bp-icon icon="search"></bp-icon>
	<input
		#searchInput
		type="search"
		[(ngModel)]="currentSearchValue"
		class="search-toolbar__input"
		(keyup)="onSearchKeyUp(searchInput.value)"
		[placeholder]="placeholder" />
</div>
